module.exports = __webpack_public_path__ + "img/devise-initial_design.1d676453.jpg";